import moment from 'moment';
export default {
    methods: {
        //funciones para el filtro
        customFilter(items, filters, filter, headers) {
            // Init the filter class.
            const cf = new this.$MultiFilters(items, filters, filter, headers);
           
            cf.registerFilter("denominacion", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.denominacion + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase()) || (item.denominacion + "")
                            .toLowerCase()
                            .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("haber_basico", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.haber_basico + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
            cf.registerFilter("estado", function (searchWord, items) {
                if (searchWord.trim() === "") return items;
                return items.filter(item => {
                    return (item.estado + "")
                        .toLowerCase()
                        .includes(searchWord.toLowerCase());
                }, searchWord);
            });
       
            return cf.runFilters();
        },

        filterDenominacion(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                denominacion: val
            });
        },
        filterHaberBasico(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                haber_basico: val
            });
        },
        filterEstado(val) {
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: val
            });
        },
     
        recargar() {
            this.form = {};
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                denominacion: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                haber_basico: ""
            });
            this.filters = this.$MultiFilters.updateFilters(this.filters, {
                estado: ""
            });
           
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/admin/item_cargo_y_puesto/mixins/filtrosCargos.js